import {
  DList,
  DListResponse,
  DObjectResponse,
  TriggerTypes,
} from 'models/common.model';

export enum PaymentMethodEnum {
  CASH = 1,
  MOMO = 2,
  TEST_PC = 3,
  RETAKE_PHOTO = 4,
  TEST_FRAME = 5,
  VNPAY = 6,
}

export enum SatisfactionLevelEnum {
  VERYSATISFIED = 1,
  SATISFIED = 2,
  NORMAL = 3,
  BAD = 4,
  VERYBAD = 5,
}

export enum IsRefundEnum {
  YES = 1,
  NO = 0,
}

export type TransactionModel = {
  id: string;
  recordAt: string;
  code: string;
  subscriberId: number;
  orderCode: string;
  storeId: number;
  boothId: number;
  layoutId: number;
  themeId: number;
  voucherId: number;
  filterId: number;
  printNumber: number;
  layoutAmount: number;
  printAmount: number;
  extraPrintNumber: number;
  discount: number;
  deposit: number;
  captureMode: number;
  purchaseDuration: number;
  captureDuration: number;
  editDuration: number;
  refundAmount: number;
  refundReason: string;
  storeName: string;
  boothName: string;
  layoutName: string;
  themeName: string;
  themeUrl: string;
  voucherName: string;
  filterName: string;
  subscriberName: string;
  staticResources: any[];
  paymentMethod?: number;
  userName?: string;
  satisfactionLevel?: number;
  feedbackEvaluationCriterias: feedbackEvaluationCriteria[];
  currencyId?: number;
  currencySymbol?: string;
};

export type feedbackEvaluationCriteria = {
  id: number;
  customerFeedbackId: number;
  feedbackEvaluationCriteriaAnswerId?: number;
  feedbackEvaluationCriteriaAnswerName?: string;
  feedbackEvaluationCriteriaId?: number;
  feedbackEvaluationCriteriaName?: string;
  starNumber?: number;
};

export type GetTransactionRequestModel = {
  id?: string;
};
export type GetTransactionResponseModel = DObjectResponse<TransactionModel>;

export type ListTransactionRequestModel = {
  subscriberId?: number;
  storeId?: number;
  boothId?: number | null;
  layoutId?: number | null;
  themeId?: number;
  filterId?: number;
  pageIndex?: number;
  pageSize?: number;
  keyword?: string;
  fromDate?: Date | string | null;
  toDate?: Date | string | null;
  paymentMethod?: number | null;
  satisfactionLevel?: number | null;
  isRefund?: number | null;
  fromTime?: Date | string | null;
  toTime?: Date | string | null;
  currencyId?: number | null;
};
export type ListTransactionResponseModel = DListResponse<TransactionModel>;

export type RefundTransactionRequestModel = {
  id?: string;
  refundReason?: string;
  refundAmount?: number;
};
export type RefundTransactionResponseModel = DObjectResponse<boolean>;

export type ExportTransactionRequestModel = ListTransactionRequestModel & {};
export type ExportTransactionResponseModel = DObjectResponse<string>;

export type DownloadImagesTransactionRequestModel =
  ListTransactionRequestModel & {};
export type DownloadImagesResponseModel = DObjectResponse<string>;

export interface TransactionStateModel {
  transactionListData: DList<TransactionModel> | null;

  transactionDetail: TransactionModel | null;

  triggerUpdateTransaction: TriggerTypes | null;

  loadingDetail: boolean;
  loadingList: boolean;
  loadingExport: boolean;
  loadingDownload: boolean;
}
